import { GQL } from "@binale-tech/shared";

import { withThinking } from "../runner/runAgent";
import type { AgentStep, ReportLine } from "../runner/types";
import { selectFillBankKeys } from "./fillBankSelection";

// The toolbar's order: merge first, then classify, then link through shared documents
const ACTIONS = [
    GQL.IFillBankAction.UnifySumRecords,
    GQL.IFillBankAction.UnifyMultipleRecords,
    GQL.IFillBankAction.FillBankGkonto,
    GQL.IFillBankAction.ConnectByDocuments,
];

export const fillBankStep: AgentStep = {
    id: "fillBank",
    product: [GQL.IProductKey.Bank],
    async run(ctx, io) {
        const keys = selectFillBankKeys(ctx.bankRecords(), ctx.year);
        if (keys.length === 0) return { status: "nothing" };

        const matched = new Set<string>();
        const ambiguous = new Set<string>();
        const journaled = new Set<string>();
        for (const action of ACTIONS) {
            if (io.isCancelled()) break;
            const results = await withThinking(io, "app.agent.fillBank.thinking", () => ctx.fillBank(action, keys));
            for (const r of results) {
                const id = String(r.transactionId);
                if (r.outcome === GQL.IFillBankOutcome.Matched) matched.add(id);
                else if (r.outcome === GQL.IFillBankOutcome.Ambiguous) ambiguous.add(id);
                else if (r.outcome === GQL.IFillBankOutcome.Journaled) journaled.add(id);
            }
        }

        const openAmbiguous = [...ambiguous].filter((id) => !matched.has(id)).length;
        const openJournaled = [...journaled].filter((id) => !matched.has(id)).length;
        const summary: ReportLine[] = [];
        const open: ReportLine[] = [];
        if (matched.size > 0) {
            io.post({ kind: "done", textId: "app.agent.fillBank.done", values: { count: matched.size } });
            summary.push({ textId: "app.agent.report.fillBankMatched", values: { count: matched.size } });
        }
        if (openAmbiguous > 0) {
            open.push({ textId: "app.agent.report.fillBankAmbiguous", values: { count: openAmbiguous } });
        }
        if (openJournaled > 0) {
            open.push({ textId: "app.agent.report.fillBankJournaled", values: { count: openJournaled } });
        }
        return { status: summary.length > 0 || open.length > 0 ? "done" : "nothing", summary, open };
    },
};
